<template>
  <Drawer :drawer="drawer" customTitle :size="882" @close="close">
    <div slot="title" class="top">
      <p class="title">
        <span>对外系统提单推送-GGT</span>
        <span class="billNo">提单号：{{ billNo }}</span>
      </p>
      <div class="file">
        <template v-if="fileList[0]?.fileName">
          <span class="file-label">提单文件：</span>
          <div class="file-item" :title="fileList[0]?.fileName">
            <img src="@/assets/images/bill/pdf.png" width="12" class="file-icon" />
            <!-- 用 span 包裹文件名，确保省略号完美生效 -->
            <span class="file-name">{{ fileList[0]?.fileName }}</span>
            <span class="review" @click="check(fileList[0])">
              <img src="@/assets/images/bill/review.png" width="12" class="file-icon" />
            </span>
          </div>
        </template>
        <template v-if="fileList[1]?.fileName">
          <span class="file-label" style="margin-left: 32px;">提单发票：</span>
          <div class="file-item" :title="fileList[1]?.fileName">
            <img src="@/assets/images/bill/pdf.png" width="12" class="file-icon" />
            <span class="file-name">{{ fileList[1]?.fileName }}</span>
          </div>
        </template>
        <div class="title-opt">
          <span class="opt-btn" style="color: #5753E8 !important" @click="dialogVisible1 = true; type = 0">
            <i class="el-icon-circle-plus-outline" />
            添加GGT抬头信息
          </span>
          <span class="opt-btn" style="color: #5753E8 !important" @click="dialogVisible1 = true; type = 1">
            <i class="el-icon-circle-plus-outline" />
            添加GGT Importer
          </span>
        </div>
      </div>
    </div>
    <div class="view">
      <div class="data">
        <el-form ref="form" class="form" :model="form" :rules="rules">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item prop="shipperSCINId" label="Shipper">
                <el-select v-model="form.shipperSCINId" style="width: 100%" filterable placeholder="请选择Shipper">
                  <el-option v-for="item in shipperOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="importerSCINId" label="Importer">
                <el-select v-model="form.importerSCINId" style="width: 100%" filterable placeholder="请选择Importer">
                  <el-option v-for="item in importerOptions" :key="item.id" :label="item.name" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="consigneeSCINId" label="Consignee">
                <el-select v-model="form.consigneeSCINId" style="width: 100%" filterable placeholder="请选择Consignee">
                  <el-option v-for="item in consigneeOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="notifyPartySCINId" label="Notify Party">
                <el-select v-model="form.notifyPartySCINId" style="width: 100%" filterable placeholder="请选择客户">
                  <el-option
                    v-for="item in notifyPartyOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="manufactureSCINId" label="manufacturer">
                <el-select v-model="form.manufactureSCINId" style="width: 100%" filterable placeholder="请选择制造商">
                  <el-option
                    v-for="item in manufactureOptions"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="remark" label="备注">
                <el-input v-model="form.remark" style="width: 100%" placeholder="请输入备注">
                </el-input>
              </el-form-item></el-col>
            <el-col :span="12">
              <el-form-item prop="doSupplierTemplateId" label="接收DO代理模板">
                <el-select
                  v-model="form.doSupplierTemplateId"
                  style="width: 100%"
                  filterable
                  placeholder="请选择接收DO代理模板"
                  @change="doChange">
                  <el-option v-for="item in doOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
                <div class="tpl-opt" @click="dialogVisible = true">模板管理</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <p class="po">
                接收DO公司名称：{{ doObj.supplierName }}
                <span style="margin-left: 24px">
                  接收DO公司邮箱：{{ doObj.emails }}
                </span>
              </p>
            </el-col>
          </el-row>
          <!-- <el-row>
            <div class="add" @click="dialogVisible1 = true">添加GGT抬头信息</div>
          </el-row>
          <el-form-item prop="shipper" label="接收DO公司名称">
            <el-input v-model="doObj.supplierName" style="width: 100%" disabled />
          </el-form-item>
          <el-form-item prop="shipper" label="接收DO公司邮箱">
            <el-input v-model="doObj.emails" style="width: 100%" disabled />
          </el-form-item> -->
          <!-- <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="提单文件">
                <div class="file">
                  <div class="file-name">
                    <img src="@/assets/images/bill/pdf.png" />
                    <div class="file-des">
                      <p v-tooltip="184" class="name">{{ fileList[0]?.fileName }}</p>
                    </div>
                  </div>
                  <div class="opt">
                    <span class="review" @click="check(fileList[0])">
                      <img src="@/assets/images/bill/review.png" />
                      预览
                    </span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="提单发票">
                <div class="file">
                  <div class="file-name">
                    <img src="@/assets/images/bill/image.png" />
                    <div class="file-des">
                      <p v-tooltip="184" class="name">{{ fileList[1]?.fileName }}</p>
                    </div>
                  </div>
                  <div class="opt">
                    <span class="no-review"> 不可预览 </span>
                  </div>
                </div>
              </el-form-item>
            </el-col>
          </el-row> -->
        </el-form>
      </div>
      <div class="footers">
        <div class="cancel flex_c_c" @click="close">取 消</div>
        <div class="ok flex_c_c" @click="ok('form')">确 定</div>
      </div>
      <DoTplDialog :dialogVisible="dialogVisible" @cancel="dialogVisible = false">
      </DoTplDialog>
      <SicnAddDialog
        :dialogVisible="dialogVisible1"
        :mblId="mblId"
        :type="type"
        @cancel="dialogVisible1 = false"
        @ok="ok1">
      </SicnAddDialog>
    </div>
  </Drawer>
</template>

<script>
const Drawer = () => import('@/components/drawer/Drawer')
import DoTplDialog from './DoTplDialog.vue'
import SicnAddDialog from './SicnAddDialog.vue'
import { GGTGetSCINList, PushMBLToGGT, getImporterDrapdown, getMBLDetail } from '@/api/bill'
import { getMBLFileList } from '@/api/bill'
// import config from '@/utils/config'
import { mapGetters } from 'vuex'
export default {
  components: { Drawer, DoTplDialog, SicnAddDialog },
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    billNo: {
      type: String,
      default: ''
    },
    mblId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      form: {
        shipperSCINId: '',
        consigneeSCINId: '',
        importerSCINId: '',
        notifyPartySCINId: '',
        manufactureSCINId: '',
        doSupplierTemplateId: '',
        remark: ''
      },
      rules: {
        shipperSCINId: [
          { required: true, message: '请选择Shipper', trigger: 'change' }
        ],
        consigneeSCINId: [
          { required: true, message: '请选择Consignee', trigger: 'change' }
        ],
        importerSCINId: [
          { required: true, message: '请选择Importer', trigger: 'change' }
        ],
        notifyPartySCINId: [
          { required: true, message: '请选择Notify Party', trigger: 'change' }
        ],
        manufactureSCINId: [
          { required: true, message: '请选择manufacture', trigger: 'change' }
        ],
        doSupplierTemplateId: [
          { required: true, message: '请选择接收DO代理模板', trigger: 'change' }
        ]
      },
      dialogVisible: false,
      dialogVisible1: false,
      loading: false,
      shipperOptions: [],
      consigneeOptions: [],
      importerOptions: [],
      notifyPartyOptions: [],
      manufactureOptions: [],
      doObj: {},
      fileList: [],
      type: 0,
      mblDetail: {}
    }
  },
  computed: {
    ...mapGetters(['doTplList']),
    doOptions() {
      return this.doTplList.map(a => {
        return {
          value: a.id,
          label: a.templateName
        }
      })
    }
  },
  watch: {
   async drawer(val) {
      if (val) {
       await this.getDetail()
        this.getScinList()
        this.getImporter()
        // this.getTpl()
        this.getFileList()
      }
    }
  },
  mounted() {
    if (this.doTplList.length === 0) {
      this.$store.dispatch('getDoTplList')
    }
  },
  methods: {
    async getDetail() {
      try {
        const result = await getMBLDetail({ mblId: this.mblId })
                if (result.success) {
                  this.loading = false
                  this.mblDetail = result.data
                  // this.form = {
                  //   shipperSCINId: result.data?.mblScinList?.find(a => a.type === 0)?.scin?.name,
                  //   consigneeSCINId: result.data?.mblScinList?.find(a => a.type === 1)?.scin?.name,
                  //   importerSCINId: result.data?.mblScinList?.find(a => a.type === 2)?.importer?.name,
                  //   notifyPartySCINId: result.data?.mblScinList?.find(a => a.type === 3)?.scin?.name,
                  //   manufactureSCINId: result.data?.mblScinList?.find(a => a.type === 4)?.scin?.name
                  // }
                } else {
                  this.$message.error(result.errorMessage)
                }
      } catch (error) {
        console.log(error)
      }
    },
    async getImporter() {
      try {
        const res = await getImporterDrapdown({ mblId: this.mblId })
        if (res.success) {
          this.importerOptions = res.data
          const name = this.mblDetail.mblScinList?.find(a => a.type === 2)?.importer?.name
          if (name) {
            this.form.importerSCINId = res.data.find(a => a.label === name)?.id
          }
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getScinList() {
      try {
        const res = await GGTGetSCINList({
          mblId: this.mblId
        })
        if (res.success) {
          this.shipperOptions = res.data.filter(a => a.type.indexOf(0) > -1).map(a => {
            return {
              value: a.id,
              label: a.name
            }
          })
          const shipper = this.mblDetail.mblScinList?.find(a => a.type === 0)?.scin?.name
          if (shipper) {
            this.form.shipperSCINId = this.shipperOptions.find(a => a.label === shipper)?.value
          }
          this.consigneeOptions = res.data.filter(a => a.type.indexOf(1) > -1).map(a => {
            return {
              value: a.id,
              label: a.name
            }
          })
          const consignee = this.mblDetail.mblScinList?.find(a => a.type === 1)?.scin?.name
          if (shipper) {
            this.form.consigneeSCINId = this.consigneeOptions.find(a => a.label === consignee)?.value
          }
          this.notifyPartyOptions = res.data.filter(a => a.type.indexOf(3) > -1).map(a => {
            return {
              value: a.id,
              label: a.name
            }
          })
          const notifyParty = this.mblDetail.mblScinList?.find(a => a.type === 3)?.scin?.name
          if (notifyParty) {
            this.form.notifyPartySCINId = this.consigneeOptions.find(a => a.label === notifyParty)?.value
          }
          this.manufactureOptions = res.data.filter(a => a.type.indexOf(4) > -1).map(a => {
            return {
              value: a.id,
              label: a.name
            }
          })
          const manufacture = this.mblDetail.mblScinList?.find(a => a.type === 4)?.scin?.name
          if (manufacture) {
            this.form.manufactureSCINId = this.manufactureOptions.find(a => a.label === manufacture)?.value
          }
        } else {
          this.$message.error(res.errorMessage)
          // this.$emit('close')
        }
      } catch (error) {
        console.log(error)
      }
    },
    async getFileList() {
      try {
        const res = await getMBLFileList({
          mblId: this.mblId
        })
        if (res.success) {
          this.fileList = res.data.filter(a => a.uploadType === 0 || a.uploadType === 5)
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    doChange(id) {
      const item = this.doTplList.find(a => a.id === id)
      this.doObj = {
        templateName: item.templateName,
        supplierName: item.supplierName,
        emails: item.emails.join(',')
      }
    },
    check(item) {
      const suffix = item.fileName.slice(
        item.fileName.lastIndexOf('.') + 1,
        item.fileName.length
      )
      const { fileGuid } = item
      if (suffix === 'jpg' || suffix === 'jpeg' || suffix === 'png') {
        this.$viewerApi({
          images: [`/api/SystemFile/preview?guid=${fileGuid}`]
        })
      } else if (suffix === 'pdf') {
        window.open(`/api/SystemFile/preview?guid=${fileGuid}`)
      } else {
        this.$message('暂时只支持图片和PDF查看')
      }
    },
    close() {
      this.$refs['form'].resetFields()
      this.$emit('close')
    },
    ok(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true // 1. 开始请求，开启 loading
          const params = {
            ...this.form,
            mblId: this.mblId
          }

          PushMBLToGGT(params).then((res) => {
            if (res.success) {
              this.$message.success('推送成功')
              this.$emit('close')
            } else {
              this.$message.error(res.errorMessage)
            }
          }).catch((err) => {
            // 2. 建议增加 catch 捕获网络异常等错误
            this.$message.error(err.message || '推送失败')
          }).finally(() => {
            // 3. 核心修复：使用 finally 确保无论成功还是失败，都会关闭 loading
            this.loading = false
          })
        }
      })
    },
    ok1() {
      this.dialogVisible1 = false
      this.getScinList()
    }
  }
}
</script>

<style lang="less" scoped>
.top {
  .title {
    display: flex;
    height: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: bold;
    font-size: 12px;
    color: #4E5969 !important;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    .billNo {
      display: inline-block;
      padding: 0 10px;
      height: 20px;
      background: #f7f7f7 !important;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: rgb(18, 88, 188) !important;
      line-height: 20px;
    }
  }

  .file {
    margin-top: 12px;
    /* 去掉固定高度，改为最小高度，防止内容被裁切 */
    min-height: 20px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    line-height: 20px;
    color: #666666 !important;
    display: flex;
    align-items: center;
    /* 👈 核心：让所有子元素垂直居中 */
    gap: 8px;
    /* 👈 核心：统一控制子元素之间的间距 */
  }

  /* 标签文字（提单文件：）禁止被压缩 */
  .file-label {
    flex-shrink: 0;
  }

  .file-item {
    display: flex;
    align-items: center;
    padding: 0 8px;
    height: 20px;
    max-width: 240px;
    background: #FFFFFF;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.12);
    border-radius: 4px;
    /* 👈 核心：允许文件框在空间不足时收缩 */
    flex-shrink: 1;
    min-width: 0;
    gap: 0px 4px;
    /* 👈 核心：配合 flex-shrink，让内部省略号生效 */
  }

  /* 文件名：承担省略号的重任 */
  .file-name {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  /* 图标禁止被压缩，防止变形 */
  .file-icon {
    flex-shrink: 0;
    vertical-align: middle;
  }

  .review {
    color: rgb(18, 88, 188);
    cursor: pointer;
    flex-shrink: 0;
    /* 预览按钮绝对不能被挤没 */
  }

  .no-review {
    color: #cdcdcd;
    cursor: not-allowed;
  }

  /* 👈 核心：右侧操作区，使用 margin-left: auto 自动推到最右侧 */
  .title-opt {
    margin-left: auto;
    flex-shrink: 0;
    /* 禁止按钮被压缩 */
    white-space: nowrap;
    /* 防止两个按钮被挤换行 */
    color: #5753E8 !important;
  }

  .opt-btn {
    cursor: pointer;
  }

  .opt-btn+.opt-btn {
    margin-left: 6px;
  }

}

.view {
  width: 100%;
  height: 100%;
  font-weight: 400;
  box-sizing: border-box;
  position: relative;

  .data {
    width: 100%;
    max-height: calc(100% - 80px);
    margin: 0 auto;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;

    .form {
      width: calc(100% - 40px);
      margin: 0 auto;
      margin-top: 10px;

      &:deep(.el-form-item__label) {
        line-height: 30px;
        font-size: 14px;
      }

      &:deep(.el-form-item) {
        margin-bottom: 10px;
        position: relative;
      }
    }

    .add {
      width: 200px;
      height: 40px;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      opacity: 1;
      margin: 10px auto;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
    }

    .po {
      width: 100%;
      height: 40px;
      padding: 0 12px;
      background: #F7F8FA;
      border-radius: 6px 6px 6px 6px;
      height: 40px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 400;
      font-size: 12px;
      line-height: 40px;
      color: #262E47;
    }

    .tpl-opt {
      position: absolute;
      top: 0;
      right: 0;
      height: 30px;
      line-height: 30px;
      font-size: 14px;
      font-weight: 400;
      color: rgb(18, 88, 188);
      cursor: pointer;
    }

    .file {
      width: 290px;
      height: 40px;
      padding: 12px 20px 12px 10px;
      background: #ffffff;
      box-shadow: 0px 0px 6px 1px rgba(0, 0, 0, 0.1);
      border-radius: 6px 6px 6px 6px;
      opacity: 1;
      display: flex;
      position: relative;
      z-index: 1;
    }

    .file-name {
      flex: 1;
      display: flex;
    }

    .file-des {
      margin-left: 10px;

      .name {
        width: 184px;
        height: 40px;
        font-size: 14px;
        font-family: Microsoft YaHei-Regular, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        line-height: 40px;
      }

      // .size {
      //   height: 16px;
      //   font-size: 12px;
      //   font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      //   font-weight: 400;
      //   color: #999999;
      //   line-height: 16px;
      //   margin-top: 4px;
      // }
    }

    .opt {
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      line-height: 40px;

      .review {
        color: rgb(18, 88, 188);
        cursor: pointer;
      }

      .no-review {
        color: #cdcdcd;
        cursor: not-allowed;
      }

      img {
        vertical-align: sub;
      }
    }
  }

  .footers {
    width: 100%;
    height: 80px;
    background: #ffffff;
    box-shadow: 0px 0px 10px 1px rgba(0, 0, 0, 0.16);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    bottom: 0;

    .cancel {
      width: 120px;
      height: 40px;
      background: #eeeeee;
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      margin-right: 16px;
      cursor: pointer;
    }

    .ok {
      width: 120px;
      height: 40px;
      background: rgb(18, 88, 188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      cursor: pointer;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #ffffff;
    }
  }
}

:deep(.el-drawer__body) {
  height: calc(100% - 80px);
}

&:deep(.el-drawer__header) {
  height: 80px;
  background: #F7F8FA;
}

&:deep(.el-drawer__header span) {
  font-size: 12px;
}
</style>
